import { sendAuthRequest } from 'src/services/api';
import { normalizeResponseErrors } from 'src/utils/normalizeResponse';

const BASE_URL = `${API_URL}dashboard-controls/solve-insights/v0`;

export const getVoiceRecording = ({
  conversation_id,
}: {
  conversation_id: string;
}): Promise<Response> => {
  return (
    sendAuthRequest(
      `${BASE_URL}/voice-recording/${conversation_id}`,
      null,
      'GET',
    )
      .then((res: Response | { error: string }) => normalizeResponseErrors(res))
      // voice recording is in bytes, just return as is
      .then((res: Response) => res)
  );
};
